<template>
  <div class="content">
    <div class="set_flexwrap" v-if="formData">
      <div class="flex_wrap">
        <p class="tip">商机阶段主要用于快速标记及衡量当前商机处于哪个销售阶段，使用商机阶段能够跟踪每个商机当前的销售状态，帮助企业管理客户资源，了解每个状态下的客户情况。</p>
        <el-form ref="form" label-width="80px">
          <template v-for="(item, index) in formData">  
            <el-form-item :label="'阶段'+(index+1)" v-if="index==0||index==formData.length-1"  :key="index">
              <div class="from_item">
                <el-input type="text" v-model="item.name"></el-input>
              </div>
            </el-form-item>
         
            <el-form-item :label="'阶段'+(index+1)" v-else :key="index">
              <div class="from_item">
                <el-input type="text" v-model="item.name"></el-input>
                <i class="el-icon-remove-outline" @click="checkLine(index)" v-if="formData.length!==3"></i>
                <i class="el-icon-circle-plus-outline" @click="addLine(index)" v-if="formData.length!==5"></i>
              </div>
            </el-form-item>
           </template>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="preview_wrap">
        <div class="grid-content bg-purple grid-content-preview">
          <p>实时预览效果</p>
          <div class="grid-img whd-grid-img">
            <div class="grid-item">
              <ul>
                <li :class="index==0?'active':''" v-for="(item, index) in formData" :key="index">阶段{{index+1}}</li>
              </ul>
              <span class="step_desp">阶段1:{{formData[0].name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "AnalyticsOpportunityBusiness",
    data() {
      return {
        formData: null
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.axios
          .post('companyadmin/task/business', {})
          .then(response => {
            if (response.data.code == 0) {
              if(!response.data.list){
                this.formData = [
                  {name:''},{name:''},{name:''}
                ]
              }else{
                this.formData = response.data.list
              }
              loading.close();
            } else {
            }
          })
          .catch(response => {
          });
      },
      addLine(index){
        this.formData.splice(Number(index)+1,0,{name:''})
      },
      checkLine(index){
        this.formData.splice(index,1)
      },
      onSubmit() {
        let status_ = 0
        let data_ = []
        for(let i in this.formData){
          if(!this.formData[i].name){
            this.$message({
              message: '请填写阶段'+(Number(i)+1)+'内容',
              type: 'warning'
            });
            return
          }
          data_.push(this.formData[i].name)
        }
        let nary = data_.sort();
        for(let i = 0; i < nary.length - 1; i++) {
          if(nary[i] == nary[i + 1]) {
            this.$message({
              message: '阶段内容"'+nary[i]+'"重复，请重新填写',
              type: 'warning'
            });
            return;
          }
        }
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.axios
          .post('companyadmin/task/business_edit', {business:this.formData})
          .then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '设置成功',
              });
              loading.close();
            } else {
            }
          })
          .catch(response => {
          });
      }
    }
  };
</script>
